<div class="custom-control custom-switch">
    <input type="checkbox" class="custom-control-input" [checked]="valor" (change)="onChange($event)" [id]="'activo' + identificador">
    <label class="custom-control-label" [for]="'activo' + identificador">{{nombre}}</label>
</div>
  